"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIES_EXPIRATION_IN_DAYS = exports.COOKIES_CONSENT_VALUE = void 0;
exports.COOKIES_CONSENT_VALUE = 'true';
exports.COOKIES_EXPIRATION_IN_DAYS = 30;
//# sourceMappingURL=fdr-cookie-disclaimer.constants.js.map